/**
 * Utility function to get list of countries
 * @returns Array of country objects with value and label
 */
export function getCountries(): Array<{ value: string; label: string }> {
  return [
    { value: '', label: 'Select Country' },
    { value: 'Global', label: 'Global' },
    { value: 'India', label: 'India' },
    { value: 'Ireland', label: 'Ireland' },
    { value: 'Italy', label: 'Italy' },
    { value: 'Malaysia', label: 'Malaysia' },
    { value: 'Malta', label: 'Malta' },
    { value: 'Mexico', label: 'Mexico' },
    { value: 'United Kingdom', label: 'United Kingdom' },
    { value: 'United States', label: 'United States' },
    { value: 'Venezuela', label: 'Venezuela' }
  ];
}

